'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    router.push('/sign-up-login-screen');
  }, [router]);

  return (
    <div data-component-id="src\app\page.tsx:13:4" data-component-path="src\app\page.tsx" data-component-line="13" data-component-end-line="15" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20flex%20items-center%20justify-center%20bg-slate-50%22%7D" className="min-h-screen flex items-center justify-center bg-slate-50">
      <div data-component-id="src\app\page.tsx:14:6" data-component-path="src\app\page.tsx" data-component-line="14" data-component-end-line="14" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-8%20h-8%20border-4%20border-blue-600%20border-t-transparent%20rounded-full%20animate-spin%22%7D" className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
